export default __webpack_public_path__ + "static/media/graphic.c9a90610.svg";